import { render, staticRenderFns } from "./EditSensor.vue?vue&type=template&id=53e879b8&scoped=true&lang=pug"
import script from "./EditSensor.vue?vue&type=script&lang=js"
export * from "./EditSensor.vue?vue&type=script&lang=js"
import style0 from "./EditSensor.vue?vue&type=style&index=0&id=53e879b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e879b8",
  null
  
)

export default component.exports